/**
 * Param keys `RequestASessionService` reads off the provider landing page URL. Shared so producer
 * and consumer resolve to a single source of truth per magic-strings rule.
 */
export enum LandingPageHeaderParam {
  ANON_USER_ID = 'anonUserId',
  NAME = 'name',
  PAYMENT_PREF = 'paymentPref',
  PAYMENT_TAG = 'paymentTag',
  PNC_ID = 'pncId',
  SHARE_CODE = 'share_code',
  /** State label as the directory sends it. */
  STATE = 'state',
  REFERRING_URL = 'referringUrl'
}
